// extracted by mini-css-extract-plugin
export default {"button":"sq","primary":"tq","fullWidth":"uq","secondary":"vq","nutrition":"wq","underlined":"xq","small":"yq","medium":"zq","info":"Aq","white":"Bq","border":"Cq","mango":"Eq","charcoal":"Fq","court":"Gq","green":"Hq","spark":"Iq","linkButton":"Jq","disabled":"Kq"};
    if(module.hot) {
      // 1713912563087
      var cssReload = require("../../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  